import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Title } from '@/components/Typography';
import { SectionScore } from './SectionScore';
import { FinalScore } from './FinalScore';
import { SectionContent } from '../styles';

export function Scores() {
	return (
		<Row justify="start" gutter={[0, 20]}>
			<Col xs={24}>
				<Title level={3}>{I18n.get('Overall results')}</Title>
			</Col>
			<Col span={24}>
				<SectionContent gutter={[0, 30]}>
					<Col span={24}>
						<FinalScore />
					</Col>
					<Col span={24}>
						<SectionScore />
					</Col>
				</SectionContent>
			</Col>
		</Row>
	);
}
